import React from "react";
import images from "../../../utilities/images/images";
import "./SectionCarouselNav.css";

const SectionCarouselNav = ({
  canScrollLeft,
  canScrollRight,
  onPrev,
  onNext,
  ariaLabel = "Carousel navigation",
}) => (
  <div className="section-carousel-nav" aria-label={ariaLabel}>
    <button
      type="button"
      className={`section-carousel-nav__btn${
        canScrollLeft ? "" : " section-carousel-nav__btn--inactive"
      }`}
      onClick={() => {
        if (canScrollLeft) onPrev();
      }}
      aria-label="Show previous items"
      aria-disabled={!canScrollLeft}
    >
      <img src={images.leftArrowCircle} alt="" aria-hidden="true" />
    </button>
    <button
      type="button"
      className={`section-carousel-nav__btn${
        canScrollRight ? "" : " section-carousel-nav__btn--inactive"
      }`}
      onClick={() => {
        if (canScrollRight) onNext();
      }}
      aria-label="Show next items"
      aria-disabled={!canScrollRight}
    >
      <img src={images.rightArrowCircle} alt="" aria-hidden="true" />
    </button>
  </div>
);

export default SectionCarouselNav;
